<app-microsites-toolbar (createNewClicked)="createNew()">
</app-microsites-toolbar>
<app-microsites [microsites]="microsites" [recordId]="recordId" [freeWallConfig]="freeWallConfig">
</app-microsites>
